<div
  class="transition-all duration-200"
  [ngClass]="{
    'w-min lg:w-[30rem]': visible && !fullscreen() && !alwaysFullscreen(),
    'w-min': !visible || fullscreen() || alwaysFullscreen()
  }"></div>

<p-drawer
  [(visible)]="visible"
  [appendTo]="fullscreen() || alwaysFullscreen() ? 'body' : appendTo"
  [modal]="false"
  position="right"
  [autoZIndex]="false"
  class="p-drawer-right"
  [styleClass]="'p-drawer-overlay absolute z-10 ' + overlayStyling()"
  (onHide)="visibleChange.emit(false)">
  <ng-template pTemplate="header">
    <div class="flex w-full items-center justify-between">
      <span class="text-xl font-semibold">{{ currentItem().typeOptions?.title }}</span>
      <button
        *ngIf="!alwaysFullscreen()"
        pButton
        class="p-button-text p-button-icon-only p-button-round p-button-sm"
        [icon]="
          fullscreen()
            ? 'fa-regular fa-arrow-down-left-and-arrow-up-right-to-center'
            : 'fa-regular fa-arrow-up-right-and-arrow-down-left-from-center'
        "
        (click)="handleFullscreen()"></button>
    </div>
  </ng-template>
  <ng-container *ngTemplateOutlet="overlayContent"></ng-container>
</p-drawer>

<ng-template #overlayContent>
  <router-outlet name="overlay"></router-outlet>
</ng-template>
